import React from 'react'
import { format } from "date-fns";
import { Button } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import './CalendarToolbar.scss'
// TODO : Find right type for toolbarProps, Type ToolbarProps seems wrong
export const CalendarToolbar = (toolbar : any) => {
    const goToBack = () => {
      toolbar.onNavigate('PREV');
    };

    const goToNext = () => {
      toolbar.onNavigate('NEXT');
    };

    const goToNextYear = () => {
        const newDate = new Date(toolbar.date);
        newDate.setFullYear(newDate.getFullYear() + 1);
        toolbar.onNavigate('DATE', newDate);
    };

    const goToBackYear = () => {
        const newDate = new Date(toolbar.date);
        newDate.setFullYear(newDate.getFullYear() - 1);
        toolbar.onNavigate('DATE', newDate);
    };

    const goToCurrent = () => {
      toolbar.onNavigate('TODAY');
    };

    const label = () => {
      return (
        format(toolbar.date, 'MMMM')+', '+format(toolbar.date, 'yyyy')
      );
    };

    return (
      <div className="calendar-toolbar">
        <div>
            <Button
                onClick={goToCurrent}
                variant="outlined"
                color="primary"
                size="small"
                className="calendar-toolbar__today"
            >today</Button>
        </div>
        <div className="calendar-toolbar__navigation">
          <button className="calendar-toolbar__backyear" onClick={goToBackYear}><NavigateBeforeIcon /><NavigateBeforeIcon /></button>
          <button className="calendar-toolbar__back" onClick={goToBack}><NavigateBeforeIcon /></button>
            <span  className="calendar-toolbar__date">{label()}</span>
          <button className="calendar-toolbar__next" onClick={goToNext}><NavigateNextIcon /></button>
          <button className="calendar-toolbar__nextyear" onClick={goToNextYear}><NavigateNextIcon /><NavigateNextIcon /></button>
        </div>
        <div></div>
      </div >
    );
  };